import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { _userList, _roles, USER_STATUS_OPTIONS, USER_STATUS_OPTIONS_ROLE } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable, emptyRows, TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TableNoData
} from 'src/components/table';

import { deleteRequest, getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import UserTableFiltersResult from './costCodes-table-filter';
import UserTableRow from './costCodes-table-list-show';
import TablePaginationApiBased from 'src/components/table/table-pagination-api-based-urls';
import { useParams } from 'react-router';
import UserTableToolbar from './costCodes-table-show-toolebar';
import { CostCodesShowCreateModal } from './cost-codes-activity-create-modal';

// ----------------------------------------------------------------------

const STATUS_OPTIONS = [ { value: 'all', label: 'All' }, ...USER_STATUS_OPTIONS ];

const TABLE_HEAD = [
    { id: 'code', label: 'Code' },
    { id: 'description', label: 'Description' },
    { id: 'quantity', label: 'Quantity' },
    { id: 'labour_hours', label: 'Labour Hours' },
    { id: 'labour_cost', label: 'Labour Cost' },
    { id: 'material_cost', label: 'Material Cost' },
    { id: 'equipment_cost', label: 'Equipment Cost' },
    { id: 'subcontractor_cost', label: 'Subcontractor Cost' },
    { id: 'total_direct_cost', label: 'Total Direct Cost' },
    { id: 'direct_unit_price', label: 'Direct Unit Price' },
    { id: 'markup_percent', label: 'Markup %' },
    { id: 'start_date', label: 'Start Date', width: 180 },
    { id: 'finish_date', label: 'Finish Date', width: 180 },
    { id: 'duration', label: 'Duration', width: 180 },
    { id: 'action', label: 'Action', width: 100 },
    { id: '', width: 88 },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
    active: 'all',
};

// ----------------------------------------------------------------------

export default function CostCodesListShow() {

    const [ tableData, setTableData ] = useState();
    console.log(tableData, 'tableData')

    const { id } = useParams()
    const table = useTable();
    const settings = useSettingsContext();
    const router = useRouter();
    const confirm = useBoolean();
    const add = useBoolean();


    useEffect(() => {
        getCostCodesDetails();
    }, [ table.page, table.rowsPerPage ]);

    const getCostCodesDetails = async (page = 1) => {
        const params = `?page=${page}`;
        const data = await getRequest(`${endpoints.admin_dashboard.teachnical_database.cost_codes.show_list}/${id}/cost-codes${params}`);
        if (data) {
            console.log("🚀 ~ getCostCodesDetails ~ data:", data)
            setTableData(data || []);
        }
    };
    const [ selectedItem, setSelectedItem ] = useState({})

    const [ filters, setFilters ] = useState(defaultFilters);
    const denseHeight = table.dense ? 52 : 72;

    const canReset = !isEqual(defaultFilters, filters);
    const notFound = (!tableData?.length < 1);


    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );

    const handleEditRow = (row) => {
        add.onTrue();
        setSelectedItem(row);
    }
    const deleteCallBack = () => {
        confirm.onFalse();
        getCostCodesDetails();
    };
    const handleDeleteRow = async (id) => {
        await deleteRequest(`${endpoints.admin_dashboard.teachnical_database.cost_codes.delete_activities}/${id}`, deleteCallBack);
    };

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    const handleclose = () => {
        add.onFalse();
        setSelectedItem({})
    }

    return (
        <>
            <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                <CustomBreadcrumbs
                    heading="Cost Codes"
                    links={ [
                        { name: '', href: paths.dashboard.root },

                    ] }
                    action={
                        <Button
                            onClick={ () => add.onTrue() }
                            variant="contained"
                            startIcon={ <Iconify icon="mingcute:add-line" /> }
                        >
                            Create
                        </Button>
                    }
                    sx={ {
                        mb: { xs: 3, md: 5 },
                    } }
                />
                <Card>
                    <Tabs
                        value={ filters.status }
                        onChange={ handleFilterStatus }
                        sx={ {
                            px: 2.5,
                            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[ 500 ], 0.08)}`,
                        } }
                    >
                        { USER_STATUS_OPTIONS_ROLE.map((tab) => (
                            <Tab
                                key={ tab.value }
                                iconPosition="end"
                                value={ tab.value }
                                label={ tab.label }
                                icon={
                                    <Label
                                        variant={
                                            ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                                        }
                                        color={
                                            (tab.value === 'active' && 'success') ||
                                            'default'
                                        }
                                    >
                                        { tab.value === 'all' && _userList.length }
                                        { tab.value === 'active' &&
                                            _userList.filter((user) => user.status === 'active').length }

                                        { tab.value === 'inactive' &&
                                            _userList.filter((user) => user.status === 'inactive').length }

                                    </Label>
                                }
                            />
                        )) }
                    </Tabs>
                    <UserTableToolbar
                        filters={ filters }
                        onFilters={ handleFilters }
                        //
                        roleOptions={ _roles }
                        reload={ () => getCostCodesDetails() }
                    />
                    { canReset && (
                        <UserTableFiltersResult
                            filters={ filters }
                            onFilters={ handleFilters }
                            //
                            onResetFilters={ handleResetFilters }
                            //
                            results={ tableData?.length }
                            sx={ { p: 2.5, pt: 0 } }
                        />
                    ) }
                    <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                        <TableSelectedAction
                            dense={ table.dense }
                            numSelected={ table?.selected.length }
                            rowCount={ tableData?.length }
                            onSelectAllRows={ (checked) =>
                                table.onSelectAllRows(
                                    checked,
                                    tableData?.map((row) => row.id)
                                )
                            }
                            action={
                                <Tooltip title="Delete">
                                    <IconButton color="primary" onClick={ confirm.onTrue }>
                                        <Iconify icon="solar:trash-bin-trash-bold" />
                                    </IconButton>
                                </Tooltip>
                            }
                        />
                        <Scrollbar>
                            <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                <TableHeadCustom
                                    order={ table?.order }
                                    orderBy={ table?.orderBy }
                                    headLabel={ TABLE_HEAD }
                                    rowCount={ tableData?.length }
                                    numSelected={ table?.selected.length }
                                    onSort={ table?.onSort }
                                    onSelectAllRows={ (checked) =>
                                        table?.onSelectAllRows(
                                            checked,
                                            tableData?.map((row) => row.id)
                                        )
                                    }
                                />
                                <TableBody>
                                    { tableData?.data?.map((row) => (
                                        <UserTableRow
                                            key={ row.id }
                                            row={ row }
                                            selected={ table.selected.includes(row.id) }
                                            onSelectRow={ () => table.onSelectRow(row.id) }
                                            onDeleteRow={ () => handleDeleteRow(row.id) }
                                            onEditRow={ () => handleEditRow(row) }
                                        />
                                    )) }

                                    <TableEmptyRows
                                        height={ denseHeight }
                                        emptyRows={ emptyRows(table?.page, table?.rowsPerPage, tableData?.length) }
                                    />
                                    <TableNoData notFound={ notFound } />
                                </TableBody>
                            </Table>
                        </Scrollbar>
                    </TableContainer>
                    { !notFound &&
                        <TablePaginationApiBased
                            paginationLinks={ tableData }
                            onPageChange={ (page) => getCostCodesDetails(page) }
                        />
                    }

                </Card>
            </Container>
            <CostCodesShowCreateModal
                open={ add.value }
                onClose={ handleclose }
                reload={ () => getCostCodesDetails() }
                currentItem={ selectedItem }

            />

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            // handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

